module.exports = __webpack_public_path__ + "img/btn-btn-now-sins-arrow.db9c87b7.svg";